import React, { useState, useEffect } from 'react';
import './css/FlipClock.css';
import './css/FlipClockPreview.css';
import { FLIP_CLOCK_SETTINGS } from '../../../../Constants/clock';
import { useSelector } from 'react-redux';

const CornerFlipClock = ({ area, dimensions, timestamp, previewMode = false }) => {
    const [time, setTime] = useState(new Date(timestamp * 1000));
    const { clockSettings, clockDisplay } = useSelector((state) => state.apps);

    const [areaHpx, setAreaHpx] = useState();
    const [areaWpx, setAreaWpx] = useState();
    const [Corner, setCorner] = useState(false);

    useEffect(() => {
        if (previewMode) {
            if (clockDisplay == "CORNER") {
                setAreaHpx(((area.height / 100) * dimensions.height));
                setAreaWpx(((area.width / 100) * dimensions.width));
            } else {
                setAreaHpx((dimensions.height));
                setAreaWpx((dimensions.width));
            }
        } else {
            if (clockDisplay == "CORNER") {
                setAreaHpx(((area.height / 100) * dimensions.height));
                setAreaWpx(((area.width / 100) * dimensions.width));
            } else {
                setAreaHpx((dimensions.height));
                setAreaWpx((dimensions.width));
            }
        }
    }, [area]);
    useEffect(() => {
        if (clockDisplay == "CORNER") {
            setCorner(true);
        }
    }, [clockDisplay]);




    useEffect(() => {
        if (timestamp) {
            const baseTime = new Date(timestamp * 1000);
            setTime(baseTime);
        }
    }, [timestamp]);


    useEffect(() => {
        const interval = setInterval(() => {
            setTime(prev => new Date(prev.getTime() + 1000));
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const formatTime = (val) => (val < 10 ? `0${val}` : val.toString());

    const getFormattedHours = () => {
        let hours = time.getUTCHours();
        if (clockSettings.timeFormat === '12') {
            hours = hours % 12 || 12;
        }
        return formatTime(hours);
    };

    const hours = getFormattedHours();
    // const hours = formatTime(time.getUTCHours());
    const minutes = formatTime(time.getMinutes());
    const seconds = formatTime(time.getSeconds());
    const dayOfWeek = time.toLocaleDateString("en-US", { weekday: "short" });

    const month = time.toLocaleDateString("en-US", { month: "short" });
    const day = time.getDate();
    const monthAndDay = `${month} ${day}`;


    const flipClockContainer = previewMode ? 'flip-clock-container-preview' : `flip-clock-container`;
    const flipClock = previewMode ? 'flip-clock-preview' : `flip-clock`;
    const flipSeparator = previewMode ? 'flip-separator-preview' : `flip-separator`;
    const flipDateContainer = previewMode ? 'flip-date-container-preview' : `flip-date-container`;



    return (
        <div className={`${flipClockContainer} gap-3`} style={{ backgroundColor: `${clockSettings.bg_color_main}`, color: `${clockSettings.text_color}` }}>

            <div className='d-flex flex-column justify-center align-items-center ' style={{
                gap: `${(Math.min(areaWpx * 0.13, areaHpx * 0.4)) / 7}px`,

            }}>
                <div className={flipDateContainer} style={{
                    width: `${Math.min(areaWpx * 0.13, areaHpx * 0.4)}px`,
                    height: `${Math.min(areaWpx * 0.09, areaHpx * 0.20)}px`,
                    fontSize: `${Math.min(areaWpx * 0.024, areaHpx * 0.08)}px`,
                    borderRadius: `${(Math.min(areaWpx * 0.13, areaHpx * 0.4)) / 10}px`,
                    boxShadow: previewMode ? `0 2px 5px ${clockSettings.shadowColor}` : `0 0.1vw 0.5vw ${clockSettings.shadowColor}`,
                    backgroundColor: `${clockSettings.bg_color_sub}`, color: `${clockSettings.text_color}`
                }} >
                    {dayOfWeek}
                    {clockSettings.timeFormat === '12' && (
                        <span style={{ fontSize: "0.8rem" }}>{time.getUTCHours() >= 12 ? ' /PM' : ' /AM'}</span>
                    )}
                </div>
                <div className={flipDateContainer} style={{
                    width: `${Math.min(areaWpx * 0.13, areaHpx * 0.4)}px`,
                    height: `${Math.min(areaWpx * 0.09, areaHpx * 0.20)}px`,
                    borderRadius: `${(Math.min(areaWpx * 0.13, areaHpx * 0.4)) / 10}px`,
                    fontSize: `${Math.min(areaWpx * 0.024, areaHpx * 0.08)}px`,
                    boxShadow: previewMode ? `0 2px 5px ${clockSettings.shadowColor}` : `0 0.1vw 0.5vw ${clockSettings.shadowColor}`,
                    backgroundColor: `${clockSettings.bg_color_sub}`, color: `${clockSettings.text_color}`
                }} >{monthAndDay}</div>

            </div>



            <div className={flipClock} style={{
                gap: `${(Math.min(areaWpx * 0.13, areaHpx * 0.4)) / 10}px`,

            }}>
                <FlipDigit areaWpx={areaWpx} areaHpx={areaHpx} Corner={Corner} previewMode={previewMode} digit={hours[0]} />
                <FlipDigit areaWpx={areaWpx} areaHpx={areaHpx} Corner={Corner} previewMode={previewMode} digit={hours[1]} />
                <div className={flipSeparator} style={{
                    fontSize: `${Math.min(areaWpx * 0.097, areaHpx * 0.5)}px`,
                    lineHeight: `${Math.min(areaWpx * 0.2, areaHpx * 0.5)}px`,
                    color: `${clockSettings.text_color}`
                }}>:</div>
                <FlipDigit areaWpx={areaWpx} areaHpx={areaHpx} Corner={Corner} previewMode={previewMode} digit={minutes[0]} />
                <FlipDigit areaWpx={areaWpx} areaHpx={areaHpx} Corner={Corner} previewMode={previewMode} digit={minutes[1]} />

            </div>


        </div>
    );
};

const FlipDigit = ({ areaWpx, areaHpx, digit, previewMode = false }) => {
    const [currentDigit, setCurrentDigit] = useState(digit);
    const [previousDigit, setPreviousDigit] = useState(digit);
    const [isAnimating, setIsAnimating] = useState(false);
    const clockSettings = useSelector((state) => state.apps.clockSettings);

    useEffect(() => {
        if (digit !== currentDigit) {
            setIsAnimating(true);
            setPreviousDigit(currentDigit);
            setTimeout(() => {
                setCurrentDigit(digit);
                setIsAnimating(false);
            }, 600);
        }
    }, [digit, currentDigit]);


    const flipDigitContainer = previewMode ? 'flip-digit-container-preview' : `flip-digit-container`;
    const flipDigit = previewMode ? 'flip-digit-preview' : `flip-digit`;
    const flipDigitTop = previewMode ? 'flip-digit-top-preview' : `flip-digit-top`;
    const flipDigitBottom = previewMode ? 'flip-digit-bottom-preview' : `flip-digit-bottom`;
    const flipDigitTopFlip = previewMode ? 'flip-digit-top-flip-preview' : `flip-digit-top-flip`;
    const flipDigitBottomFlip = previewMode ? 'flip-digit-bottom-flip-preview' : `flip-digit-bottom-flip`;

    return (
        <div className={flipDigitContainer} style={{ backgroundColor: `${clockSettings.bg_color_sub}`, color: `${clockSettings.text_color}` }}>
            <div className={`${flipDigit} ${isAnimating ? 'flipping' : ''}`} style={{
                height: `${Math.min(areaWpx * 0.2, areaHpx * 0.5)}px`,
                width: `${Math.min(areaWpx * 0.1, areaHpx * 0.3)}px`,
                fontSize: `${Math.min(areaWpx * 0.097, areaHpx * 0.5)}px`,

                borderRadius: `${(Math.min(areaWpx * 0.13, areaHpx * 0.4)) / 10}px`,

                lineHeight: `${Math.min(areaWpx * 0.2, areaHpx * 0.5)}px`,


                boxShadow: previewMode ? `0 2px 5px ${clockSettings.shadowColor}` : `0 0.1vw 0.5vw ${clockSettings.shadowColor}`,
                backgroundColor: `${clockSettings.bg_color_sub}`, color: `${clockSettings.text_color}`
            }}>
                <div className={flipDigitTop} style={{
                    lineHeight: `${Math.min(areaWpx * 0.2, areaHpx * 0.5)}px`,
                    backgroundColor: `${clockSettings.bg_color_flip}`, color: `${clockSettings.text_color}`
                }}>{currentDigit}</div>
                <div className={flipDigitBottom} style={{ backgroundColor: `${clockSettings.bg_color_flip}`, color: `${clockSettings.text_color}` }}>{isAnimating ? previousDigit : currentDigit}</div>
                {isAnimating && (
                    <>
                        <div className={flipDigitTopFlip} style={{
                            lineHeight: `${Math.min(areaWpx * 0.2, areaHpx * 0.5)}px`,
                            backgroundColor: `${clockSettings.bg_color_flip}`, color: `${clockSettings.text_color}`
                        }}>{previousDigit}</div>
                        <div className={flipDigitBottomFlip} style={{ backgroundColor: `${clockSettings.bg_color_flip}`, color: `${clockSettings.text_color}` }}>{currentDigit}</div>
                    </>
                )}
            </div>
        </div >
    );
};

export default CornerFlipClock;